/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import "./src/styles/global.css"

const forceScrollTop = () => {
  if (typeof window === "undefined") return

  const html = document.documentElement
  const body = document.body
  const previousHtmlScrollBehavior = html.style.scrollBehavior
  const previousBodyScrollBehavior = body.style.scrollBehavior

  html.style.scrollBehavior = "auto"
  body.style.scrollBehavior = "auto"
  window.scrollTo(0, 0)

  window.requestAnimationFrame(() => {
    window.scrollTo(0, 0)
    html.style.scrollBehavior = previousHtmlScrollBehavior
    body.style.scrollBehavior = previousBodyScrollBehavior
  })
}

export const onRouteUpdate = ({ location }) => {
  if (!location.hash) forceScrollTop()
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) return true
  return false
}
